export const roles = {
  editor: { value: "Editor", name: "Editor" },
  viewer: { value: "Viewer", name: "Viewer" },
}
